import React, { useState } from 'react';
import * as Yup from 'yup';
import {
	Box,

	Button,

} from '@chakra-ui/react'
import { InputText, Form } from '../../../components/form'
import { toast } from "react-toastify";
import { fetchWrapper } from '../../../helpers';

function Create({ meClose, loadList }) {



	const [formData, setFormData] = useState({
		username: '',
		email: '',
		password: '',
		customer_id: '0'

	});

	const FormSchema = Yup.object().shape({
		username: Yup.string().required('Required'),
		email: Yup.string()
			.email('Invalid email address')
			.required('Email is required'),

		password: Yup.string()
			.min(8, 'Password must be at least 8 characters')
			.matches(/\d/, 'Password must contain at least one digit')
			.matches(/[a-zA-Z]/, 'Password must contain at least one letter')
			.matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character')
			.required('Password is required'),

	});








	const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {

		let data = values


		const url = `${process.env.REACT_APP_API_URL}/user/create`;
		const response = await fetchWrapper.post(url, data)

		if (response?.status) {
			toast(response?.message, {
				type: "error"
			});
			return

		} else {
			loadList()
			meClose();
			toast(response?.message, {
				type: "info"
			});
		}

	}

	return (


		<Form
			enableReinitialize
			validationSchema={FormSchema}
			initialValues={formData}
			onSubmit={onSubmit}
		>

			<Box mb="10px">
				<InputText name="username" title="Full Name" inputProps={{ isRequired: true }} placeholder="Please Enter Full Name" />
			</Box>
			<Box mb="10px">
				<InputText name="email" title="Email" inputProps={{ isRequired: true }} placeholder="Please Enter Email" />
			</Box>
			<Box mb="10px">
				<InputText name="password" title="Password" inputProps={{ type: 'password', isRequired: true }} placeholder="Please input Password" />
			</Box>





			<Button py="10px" px="25px" color="#fff" bg="#2563eb" fontSize="14px" fontWeight="500" fontFamily="'Open Sans', sans-serif"
				mb={4}

				type='submit'
			>
				Add New User
			</Button>
		</Form>


	)
}

export default Create;